import { useContext, useCallback } from "react";
import { StateContext, useFetchDispatcher } from "@rest-hooks/core";
function selectMeta(state, fetchKey) {
    return state.meta[fetchKey];
}
function selectExpiresAt(state, fetchShape, params, entitiesExpireAt = 0) {
    const { getFetchKey } = fetchShape;
    const key = params ? getFetchKey(params) : "";
    const meta = selectMeta(state, key);
    if (!meta) {
        return entitiesExpireAt;
    }
    // Temporarily prevent infinite loops until invalidIfStale is revised
    if (fetchShape.options?.invalidIfStale &&
        meta.prevExpiresAt &&
        meta.expiresAt - meta.prevExpiresAt < 1000) {
        return meta.expiresAt + 2000;
    }
    return meta.expiresAt;
}
export default function usePreFetcher() {
    const state = useContext(StateContext);
    const dispatchFetcher = useFetchDispatcher(true);
    return useCallback((fetchShape, params, body, entitiesExpireAt = 0) => {
        const expiresAt = selectExpiresAt(state, fetchShape, params, entitiesExpireAt);
        if (Date.now() < expiresAt || !params)
            return;
        return dispatchFetcher(fetchShape, params, body);
    }, [dispatchFetcher, state]);
}
//# sourceMappingURL=usePreFetcher.js.map